import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 mb-4">
            <i className="ri-star-line text-secondary-600 text-sm"></i>
            <span className="text-secondary-700 text-xs font-medium">为什么选择我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，让吃瓜更专业、更可信、更有趣
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-200 cursor-default"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 transition-colors group-hover:bg-primary-500">
                <i className={`${item.icon} text-primary-600 text-2xl transition-colors group-hover:text-background-50`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}